import { validateContentSearch } from "../features/content/search";
import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminCategoriesRoute } from "../pages/AdminContentRoutes";

export const Route = createFileRoute("/system/content/categories")({ validateSearch: validateContentSearch, component: () => <ProtectedPage><AdminCategoriesRoute /></ProtectedPage> });
